import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon, Tag } from '@fiverr-private/fit';
import { grey_1200, orange_1100, red_1100 } from '@fiverr-private/sass/helpers';
import { useLocalizationContext } from '../../contexts/LocalizationContext';
import { getHighlightContent } from './highlights';
import { highlightTypes } from './constants';

import styles from './Highlight.module.scss';

const getHighlightColor = (type, isPro = false) => {
    switch (type) {
        case highlightTypes.inactiveSeller: {
            return {
                tag: Tag.COLORS.RED_100,
                icon: red_1100,
                className: styles.redHighlight,
            };
        }
        case highlightTypes.sellerOnVacation: {
            return {
                tag: Tag.COLORS.ORANGE_100,
                icon: orange_1100,
                className: styles.orangeHighlight,
            };
        }
        default: {
            return {
                tag: Tag.COLORS.LIGHT_GREY,
                icon: grey_1200,
                className: isPro ? styles.proHighlight : styles.defaultHighlight,
            };
        }
    }
};

/** @type {import('./index').Highlight} */
const Highlight = ({ className, type, additionalData = {} }) => {
    const { dateTimeFormat } = useLocalizationContext();
    const highlightContent = getHighlightContent(type, additionalData, dateTimeFormat);
    const highlightColor = getHighlightColor(type, additionalData.isPro);

    return (
        <Tag
            className={classnames(className, styles.highlightTag, highlightColor.className)}
            size={Tag.SIZES.SMALL}
            color={highlightColor.tag}
            borderRadius={Tag.BORDER_RADIUSES.ROUNDED}
        >
            <Icon color={highlightColor.icon}>{highlightContent.icon}</Icon>
            <span className="m-l-8 text-semi-bold">{highlightContent.text}</span>
        </Tag>
    );
};

Highlight.propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    additionalData: PropTypes.object,
};

export default Highlight;
